import { ColumnResizeHandleProps } from '@/components/Table/types'

export const ColumnResizeHandle = ({ header }: ColumnResizeHandleProps) => {
	return (
		<div
			onMouseDown={header.getResizeHandler()}
			onTouchStart={header.getResizeHandler()}
			className={`absolute bg-[rgb(61,122,136)]  -right-[0.7px] top-0 h-full w-1 cursor-col-resize select-none touch-none opacity-100 hover:transition-opacity ${
				header.column.getIsResizing()
					? 'opacity-100 bg-blue-500'
					: 'bg-gray-300 hover:bg-blue-400'
			}`}
		/>
	)
}
